module.exports = __webpack_public_path__ + "d4923f7ff5e14fd69e27118e84b42667.pdf";